import { createContext, useContext, useState, useCallback, type ReactNode } from "react";

interface PrivacyContextValue {
  revealed: boolean;
  toggle: () => void;
}

const PrivacyContext = createContext<PrivacyContextValue>({ revealed: false, toggle: () => {} });

const STORAGE_KEY = "privacy-revealed";

export function PrivacyProvider({ children }: { children: ReactNode }) {
  const [revealed, setRevealed] = useState(() => sessionStorage.getItem(STORAGE_KEY) === "true");

  const toggle = useCallback(() => {
    setRevealed((prev) => {
      const next = !prev;
      sessionStorage.setItem(STORAGE_KEY, String(next));
      return next;
    });
  }, []);

  return (
    <PrivacyContext.Provider value={{ revealed, toggle }}>
      {children}
    </PrivacyContext.Provider>
  );
}

export function usePrivacy() {
  return useContext(PrivacyContext);
}
